import { Component, Input } from '@angular/core';
import { FeatureFlag } from '@app/enums';
import { WorkersCompensation } from '@app/models/payroll/workers-compensation.model';
import { NotifyService } from '@app/services';
import { AuthService } from '@app/services/auth.service';
import { FeatureService } from '@app/services/feature.service';
import { BaseForm } from '@forms/base.form';
import { Office } from '@models/company/office.model';

@Component({
    selector: 'app-workers-compensation-rate-form',
    templateUrl: './workers-compensation-rate.template.html',
})
export class WorkersCompensationRateForm extends BaseForm {
    @Input() workersCompensation: WorkersCompensation = new WorkersCompensation();
    @Input() isEditMode = false;
    country = 'Canada';
    title = 'components.workers-compensation-rate.title';
    years: number[] = [];
    jurisdictions: string[] = [];

    constructor(
        private auth: AuthService,
        private features: FeatureService,
        private notify: NotifyService
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.years = this.getValidRangeOfYears();
        try {
            this.jurisdictions = await this.loadValidJurisdictions();
        } catch (err) {
            this.notify.error(err);
        }
    }

    submit(): void {
        this.form.onSubmit(null);
    }

    private getValidRangeOfYears(): number[] {
        const start = 2023;
        const end = new Date().getFullYear() + 1;
        const diffInYears = end - start;

        return Array(diffInYears + 1)
            .fill(start)
            .map((year, index) => year + index)
            .sort();
    }

    private async loadValidJurisdictions(): Promise<string[]> {
        const [[offices], hasQcPayroll] = await Promise.all([
            Office.param('company', this.auth.company.id).orderBy('province', 'ASC').all(),
            this.features.has(FeatureFlag.qcPayroll),
        ]);

        const uniqueOffices = new Set<string>(
            offices
                .filter(
                    (office) =>
                        office.province !== undefined &&
                        // We do not support QC yet, and NT and NU do not have workers compensation
                        (office.province !== 'QC' || hasQcPayroll) &&
                        office.province !== 'NT' &&
                        office.province !== 'NU'
                )
                .map((office: Office) => office.province as string)
        );

        return Array.from(uniqueOffices);
    }
}
